export const openLoadStatuses = {
  'status-available': {
    id: 0,
    filterType: 'status',
    title: 'Available',
    longTitle: 'Status: Available',
    query: '&q[status_in][]=available',
  },
  'status-covered': {
    id: 1,
    filterType: 'status',
    title: 'Covered',
    longTitle: 'Status: Covered',
    query: '&q[status_in][]=covered',
  },
  'status-progress': {
    id: 2,
    filterType: 'status',
    title: 'Progress',
    longTitle: 'Status: In Progress',
    query: '&q[status_in][]=progress',
  },
  'status-delayed': {
    id: 3,
    filterType: 'status',
    title: 'Delayed',
    longTitle: 'Status: Delayed',
    query: '&q[status_in][]=delayed',
  },
};

export const trackingWindow = {
  'future-window': {
    filterType: 'trackingWindow',
    query: '&q[before_active_tracking_window]=1',
    title: 'Not Started',
    longTitle: 'Window: Not Started',
  },
  'current-window': {
    filterType: 'trackingWindow',
    query: '&q[within_active_tracking_window]=1',
    title: 'Active',
    longTitle: 'Window: Active',
  },
  'past-window': {
    filterType: 'trackingWindow',
    query: '&q[after_active_tracking_window]=1',
    title: 'Ended',
    longTitle: 'Window: Ended',
  },
};

export const combinedTrackingWindow = {
  'cp-window': {
    filterType: 'trackingWindow',
    title: 'Active Or Ended',
    longTitle: 'Window: Active Or Ended ',
    query: '&q[after_and_within_active_tracking_window]=1',
  },
  'cf-window': {
    filterType: 'trackingWindow',
    title: 'Active Or Not Started',
    longTitle: 'Window: Active Or Not Started',
    query: '&q[before_and_within_active_tracking_window]=1',
  },
};

export const exceptionLoadStatuses = {
  'status-covered': {
    id: 1,
    filterType: 'status',
    title: 'Covered',
    longTitle: 'Status: Covered',
    query: '&q[status_in][]=covered',
  },
  'status-progress': {
    id: 2,
    filterType: 'status',
    title: 'Progress',
    longTitle: 'Status: In Progress',
    query: '&q[status_in][]=progress',
  },
};

export const trackingAssignedVehicleStatuses = {
  'assigned-vehicle': {
    id: 1,
    filterType: 'tracking',
    title: 'Tracking',
    query: '&q[active_and_tracking]=1',
  },
  'no-assigned-vehicle': {
    id: 2,
    filterType: 'tracking',
    title: 'Not Tracking',
    query: '&q[active_unassigned_with_eld_carrier]=1',
  },
};

export const trackingAssignedVehicleStatusesV2 = {
  tracking: {
    id: 1,
    filterType: 'tracking',
    title: 'Tracking',
    longTitle: 'Tracking: Tracking',
    query: '&q[tracking_status_in][]=tracking',
  },
  'not-started': {
    id: 2,
    filterType: 'tracking',
    title: 'Tracking Not Started',
    longTitle: 'Tracking: Not Started',
    query: '&q[tracking_status_in][]=not_started',
  },
  'no-eld-connection': {
    id: 4,
    filterType: 'tracking',
    title: 'No ELD Connection',
    longTitle: 'Tracking: No ELD Connection',
    query: '&q[tracking_status_in][]=no_eld_connection',
  },
  interrupted: {
    id: 5,
    filterType: 'tracking',
    title: 'Interrupted',
    longTitle: 'Tracking: Interrupted',
    query: '&q[tracking_status_in][]=tracking_interrupted',
  },
  terminated: {
    id: 6,
    filterType: 'tracking',
    title: 'Terminated',
    longTitle: 'Tracking: Terminated',
    query: '&q[tracking_status_in][]=terminated',
  },
  ended: {
    id: 7,
    filterType: 'tracking',
    title: 'Ended',
    longTitle: 'Tracking: Ended',
    query: '&q[tracking_status_in][]=ended',
  },
  'unable-to-track': {
    id: 8,
    filterType: 'tracking',
    title: 'Unable to Track',
    longTitle: 'Tracking: Unable to Track',
    query: '&q[tracking_status_in][]=unable_to_track',
  },
  // 'physical-location-within-range-of-origin': {
  //   id: 6,
  //   filterType: 'tracking',
  //   title: 'Physical Location Within Range of Origin',
  //   query:
  //     '&q[latest_tracking_type_load_log_is_type_in][]=physical_location_within_range_of_origin',
  // },
};

export const loadVehicleStatuses = {
  assigned: {
    id: 1,
    filterType: 'vehicle',
    title: 'Assigned',
    longTitle: 'Vehicle: Assigned',
    query: '&q[assigned]=1',
  },
  // 'needs-assignment': {
  //   id: 1,
  //   filterType: 'vehicle',
  //   title: 'Needs Assignment',
  //   longTitle: 'Vehicle: Needs Assignment',
  //   query: '&q[active_unassigned_with_eld_carrier]=1',
  // },
  unassigned: {
    id: 1,
    filterType: 'vehicle',
    title: 'Unassigned',
    longTitle: 'Vehicle: Unassigned',
    query: '&q[unassigned]=1',
  },
};

export const closedLoadStatuses = {
  'status-delivered': {
    id: 3,
    filterType: 'status',
    title: 'Delivered',
    longTitle: 'Status: Delivered',
    query: '&q[status_in][]=delivered',
  },
  'status-canceled': {
    id: 4,
    filterType: 'status',
    title: 'Cancelled',
    longTitle: 'Status: Cancelled',
    query: '&q[status_in][]=cancelled',
  },
  'status-assumed-delivered': {
    id: 5,
    filterType: 'status',
    title: 'Assumed Delivered',
    longTitle: 'Status: Assumed Delivered',
    query: '&q[status_in][]=assumed_delivered',
  },
};

export const eldConnected = {
  'is-eld-connected': {
    id: 6,
    filterType: 'eld',
    title: 'ELD Connected',
    query: '&q[carrier_rule_has_eld_connected_and_active_eq]=2',
  },
};

export const trackingEligibility = {
  trackable: {
    id: 1,
    filterType: 'trackingEligibility',
    title: 'Trackable',
    longTitle: 'Eligibility: Trackable',
    query: '&q[billable_miles_gteq]=150',
  },
  'not-trackable': {
    id: 2,
    filterType: 'trackingEligibility',
    title: 'Not Trackable',
    longTitle: 'Eligibility: Not Trackable',
    query: '&q[billable_miles_lt]=150',
  },
};

export const loadDropdownSearchFields = [
  { id: 'carrier', label: 'Carrier Name' },
  { id: 'dot', label: 'Carrier DOT' },
  { id: 'loadId', label: 'Load ID' },
  // { id: 'origin', label: 'Origin City' },
  // { id: 'destination', label: 'Destination City' },
];

export const loadSearchFields = {
  carrier: {
    id: 1,
    title: 'Carrier Name',
    query: '&q[legal_name_search_or_dba_name_search_cont]',
  },
  dot: { id: 2, title: 'Carrier DOT', query: '&q[dot_cont]' },
  loadId: { id: 3, title: 'Load ID', query: '&q[shipment_identifier_cont]' },
  shipperId: {
    id: 4,
    title: 'Shipper ID',
    query: '&q[order_shipper_external_id_cont]',
  },
  // origin: { id: 4, title: 'Origin City', query: 'q[origin_city_cont]' },
  // destination: {
  //   id: 5,
  //   title: 'Destination City',
  //   query: 'q[destination_city_cont]',
  // },
  // originState: 'Origin State',
  // originZip: 'Origin Zip',
  // destinationState: 'Destination State',
  // destinationZip: 'Destination Zip',
};

export const alertStatuses = {
  new: {
    id: 0,
    filterType: 'status',
    title: 'New',
    query: '&q[status_in][]=new',
  },
  'in-progress': {
    id: 1,
    filterType: 'status',
    title: 'In Progress',
    query: '&q[status_in][]=in_progress',
  },
  escalated: {
    id: 2,
    filterType: 'status',
    title: 'Escalated',
    query: '&q[status_in][]=escalated',
  },
  closed: {
    id: 3,
    filterType: 'status',
    title: 'Closed',
    query: '&q[status_in][]=closed',
  },
};

export const defaultLoadFilters = {
  active: '',
  'no-eld': '_status-covered_status-progress',
  'no-arrival': '_status-covered_status-progress_current-window',
  'no-departure': '_status-covered_status-progress_current-window',
  'no-assigned-vehicle': '_status-covered_status-progress',
  'pending-tracking': '_status-covered_status-progress_future-window',
  'not-tracking':
    '_status-covered_status-progress_interrupted_terminated_current-window',
  'no-pickup': '_status-covered_status-progress',
  'no-delivery': '_status-covered_status-progress',
  closed: '',
};

export const defaultLoadSort = {
  active: 'origin_asc',
  'no-eld': 'origin_asc',
  'no-arrival': 'origin_asc',
  'no-departure': 'origin_asc',
  'no-assigned-vehicle': 'origin_asc',
  'pending-tracking': 'origin_asc',
  'not-tracking': 'origin_asc',
  'no-pickup': 'origin_asc',
  'no-delivery': 'origin_asc',
  closed: 'destination_desc',
};

export const loadFilters = {
  ...combinedTrackingWindow,
  ...trackingWindow,
  ...openLoadStatuses,
  ...closedLoadStatuses,
  ...eldConnected,
  ...trackingAssignedVehicleStatuses,
  ...trackingAssignedVehicleStatusesV2,
  ...loadVehicleStatuses,
  ...alertStatuses,
  ...exceptionLoadStatuses,
  ...trackingEligibility,
};
